// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Table-Cells-CellLog-___CellLog-module__readContainer {
  padding: 3px;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
  border: 1px solid transparent;
}

.app-components-Table-Cells-CellLog-___CellLog-module__date {
  text-align: start;
  font-size: 12px;
  white-space: nowrap;
}

.app-components-Table-Cells-CellLog-___CellLog-module__top {
  height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.app-components-Table-Cells-CellLog-___CellLog-module__isCollapsedTextIcon {
  padding: 1px 8px;
  background-color: white;
  border-radius: 3px;
}

.app-components-Table-Cells-CellLog-___CellLog-module__isCollapsedTextIcon:hover {
  color: rgba(0, 0, 0, 0.7);
}
`, "",{"version":3,"sources":["webpack://./app/components/Table/Cells/CellLog/CellLog.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".readContainer {\n  padding: 3px;\n  height: 100%;\n  background-color: transparent;\n  overflow: hidden;\n  border: 1px solid transparent;\n}\n\n.date {\n  text-align: start;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.top {\n  height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.isCollapsedTextIcon {\n  padding: 1px 8px;\n  background-color: white;\n  border-radius: 3px;\n}\n\n.isCollapsedTextIcon:hover {\n  color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"readContainer": `app-components-Table-Cells-CellLog-___CellLog-module__readContainer`,
	"date": `app-components-Table-Cells-CellLog-___CellLog-module__date`,
	"top": `app-components-Table-Cells-CellLog-___CellLog-module__top`,
	"isCollapsedTextIcon": `app-components-Table-Cells-CellLog-___CellLog-module__isCollapsedTextIcon`
};
export default ___CSS_LOADER_EXPORT___;
